import { render, staticRenderFns } from "./MFASetup.vue?vue&type=template&id=623a8bc1&scoped=true&"
import script from "./MFASetup.vue?vue&type=script&lang=ts&"
export * from "./MFASetup.vue?vue&type=script&lang=ts&"
import style0 from "./MFASetup.vue?vue&type=style&index=0&id=623a8bc1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a8bc1",
  null
  
)

export default component.exports